import Vue from "vue";
import VueRouter from "vue-router";
import About from "../components/About.vue";
import Home from "../components/Home.vue";

Vue.use(VueRouter);

const routes = [
 
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/About",
    name: "About",
    component: About,
    meta: {
      analytics: {
        path: "/About/",
      },
    },
  },
];

const router = new VueRouter({
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 };
  },
});


export default router;
